<!-- viewer-img.component.html -->
<p-galleria
    *ngIf="images && images.length > 0"
    [value]="images"
    [(visible)]="displayImgView"
    [containerStyle]="{ 'max-width': '850px' }"
    [numVisible]="7"
    [circular]="true"
    [fullScreen]="true"
    [showItemNavigators]="false"
    [showThumbnails]="false"
>
    <ng-template pTemplate="item" let-item>
        <div class="relative p-shadow-2 p-border-round">
            <shared-loader [hidden]="!_showLoader"></shared-loader>

            <div
                *ngIf="images.length > 0 && !_showLoader && validImage"
                class="absolute top-0 left-0 w-full text-center p-shadow-2 p-bg-primary p-p-2"
            >
        <span class="title">
          Archivo: {{ item.name || 'Nombre no disponible' }}
        </span>
            </div>

            <div
                *ngIf="!_showLoader && !validImage"
                class="top-0 left-0 w-full text-center p-shadow-2 p-bg-primary p-p-2"
            >
        <span class="title">
          Archivo no disponible en estos momentos
        </span>
            </div>

            <!-- Ahora, si item.blobUrl emite SafeUrl, se muestra la imagen -->
            <img
                *ngIf="(item.blobUrl | async) as safeImageUrl"
                [src]="safeImageUrl"
                class="w-full h-auto block p-border-round"
                (load)="imageLoaded($event)"
                (error)="imageLoaded($event)"
                alt="{{ item.name || 'Imagen protegida' }}"
            />
        </div>
    </ng-template>
</p-galleria>
